import { StarRatingContainer } from '../../containers/filters/StarRatingContainer';
import { EFilterType, IFilter } from '../../types/filters';

export const starRating: IFilter = {
  availability: ({ config }) => Boolean(config.get<boolean>('Dailyrent.HotelsStarRatingFilter.Enabled')),
  component: StarRatingContainer,
  type: EFilterType.Openable,
};
